module.exports = __webpack_public_path__ + "static/media/KAYO.4d75fc67.png";